import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as debounce_1 } from './index4.js';
import './index2.js';
import { D as DomService } from './index3.js';
import { b as breakpoints } from './index5.js';

const rocheTextImageCss = "roche-text-image{display:block;margin-top:3rem;clear:both}@media (min-width: 90rem){roche-text-image{margin-top:4.5rem}}roche-text-image,roche-text-image *{box-sizing:border-box}roche-text-image[align-image-left]+roche-accordion-tabs{padding-top:2.25rem;overflow:hidden;width:100%}@media (min-width: 64rem){roche-text-image[align-image-left] roche-image:not([fullscreen]){float:left;margin:0.75rem 3rem 0 0}roche-text-image[align-image-left] roche-image:not([fullscreen])~*{display:inline}roche-text-image[align-image-left] roche-richtext ul>li{overflow:hidden}roche-text-image[align-image-left] roche-richtext ul>li::before{margin-left:0.125rem}}@media (min-width: 64rem){roche-text-image[align-image-right] roche-image:not([fullscreen]){float:right;margin:0.75rem 0 1.5rem 3rem}}roche-text-image roche-image{margin-top:0 !important}";
const RocheTextImageStyle0 = rocheTextImageCss;

const accordionTabsTag = 'roche-accordion-tabs';
const accordionTabsItemTag = 'roche-accordion-tabs-item';
const debounceTime = 50;
const gridTag = 'roche-grid';
const gridContainerTag = 'roche-container';
const imageTag = 'roche-image';
const totalColumns = 12;
const columnSpan = 4;
const columnOffset = 2;
const RocheTextImage$1 = /*@__PURE__*/ proxyCustomElement(class RocheTextImage extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.slottedImage = null;
        this.alignImageLeft = false;
        this.alignImageRight = false;
        this.manageAlignImageLeft = debounce_1.debounce(this.manageAlignImageLeft.bind(this), debounceTime);
        this.manageAlignImageRight = debounce_1.debounce(this.manageAlignImageRight.bind(this), debounceTime);
    }
    componentDidLoad() {
        var _a, _b, _c;
        this.gridElement = this.element.closest(gridTag);
        this.gridContainerAncestor = (_b = (_a = this.gridElement) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector(gridContainerTag);
        this.accordionTabsElement = this.element.closest(accordionTabsTag);
        this.accordionTabsItemAncestor = (_c = this.accordionTabsElement) === null || _c === void 0 ? void 0 : _c.querySelector(accordionTabsItemTag);
        this.slottedImage = this.element.querySelector(imageTag);
        if (this.shouldAlignImageLeft()) {
            DomService.createObserver(this.gridContainerAncestor, this.manageAlignImageLeft);
            this.render();
        }
        if (this.shouldAlignImageRight()) {
            DomService.createObserver(this.gridContainerAncestor, this.manageAlignImageRight);
            this.render();
        }
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return (h(Host, { key: '700146ba867cdeb981d6acba9d62fe9672c75595' }, h("slot", { key: '0b12a484fdd852da0df37dcd9da319232c334180', name: "image" }), h("slot", { key: '0529aee3a74475982a570d430beeb4cb207a85d4', name: "content" })));
    }
    shouldAlignImageLeft() {
        if (!this.gridContainerAncestor || !this.slottedImage || this.alignImageRight) {
            return false;
        }
        // fullscreen images should never align left
        if (this.slottedImage.fullscreen) {
            return false;
        }
        return this.alignImageLeft;
    }
    shouldAlignImageRight() {
        if (!this.gridContainerAncestor || !this.slottedImage) {
            return false;
        }
        // fullscreen images should never align left
        if (this.slottedImage.fullscreen) {
            return false;
        }
        return this.alignImageRight;
    }
    manageAlignImageLeft() {
        var _a;
        const { width } = this.gridContainerAncestor.getBoundingClientRect();
        const inlineStyle = window.innerWidth > breakpoints.large ? `
      width: ${(width / totalColumns) * columnSpan}px;
      margin-left: ${!this.accordionTabsItemAncestor && ((_a = this.gridElement) === null || _a === void 0 ? void 0 : _a.layout) === '8' ? -(width / totalColumns) * columnOffset : 0}px;
    ` : '';
        this.slottedImage.setAttribute('style', inlineStyle);
    }
    manageAlignImageRight() {
        const { width } = this.gridContainerAncestor.getBoundingClientRect();
        const inlineStyle = window.innerWidth > breakpoints.large ? `
      width: ${(width / totalColumns) * columnSpan}px;
      margin-right: 0;
    ` : '';
        this.slottedImage.setAttribute('style', inlineStyle);
    }
    get element() { return this; }
    static get style() { return RocheTextImageStyle0; }
}, [4, "roche-text-image", {
        "alignImageLeft": [4, "align-image-left"],
        "alignImageRight": [4, "align-image-right"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-text-image"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-text-image":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheTextImage$1);
            }
            break;
    } });
}

const RocheTextImage = RocheTextImage$1;
const defineCustomElement = defineCustomElement$1;

export { RocheTextImage, defineCustomElement };

//# sourceMappingURL=roche-text-image.js.map